/**
 * 生成一个加载中的组件
 * @returns JSX.Element
 */
export default function generateLoading() {
    return <div>Loading...</div>;
}
